import { goToRoute } from "../goToRoute/goToRoute";

export const removeDomain = (domain, tld) => {
  return async (dispatch, getState, { api }) => {
    const state = getState();
    // API call to remove the domain
    return api.removeDomain(domain, tld).then(
      (data) => {
        if (
          state.cart.cartItems.length - 1 === 0 &&
          (state.routing.pageName === "addExtras" ||
            state.routing.pageName === "customerDetails" ||
            state.routing.pageName === "payment")
        ) {
          dispatch(goToRoute({ pageName: "domainSearch" }));
          return { ...data, redirected: true };
        }
        return data;
      },
      (err) => {
        return err;
      },
    );
  };
};
